<template>
  <PulseMultiSelectDropdown
    :items="items"
    :title="t('buttons.addFilter')"
    :dropdown-width="'300px'"
    placeholder="Add filter..."
    :selected-options="props.selectedOptions?.map(f => ({ label: f.field, value: f.field })) || []"
    @update:model-value="handleOptionClick"
  />
</template>

<script setup lang="ts">
import { FilterConfig, FilterQuery } from '@monolog/shared/types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
  filterOptions: {
    required: true,
    type: Array as PropType<FilterConfig[]>,
  },
  selectedOptions: {
    required: true,
    type: Array as PropType<FilterQuery[]>,
  },
});

const items = computed(() => props.filterOptions.map(f => ({ label: f.label, value: f.field })));

const emit = defineEmits<{
  (event: 'addFilter', option: string): void;
}>();

const handleOptionClick = (option: string) => {
  emit('addFilter', option);
};
</script>

<i18n lang="json">
{
  "en": {
    "buttons": {
      "addFilter": "Add filter"
    }
  }
}
</i18n>
